import contentPathUrlMapper from '../../src/utils/contentURLMapper';
import ESI from '../../src/components/ESI';
import logControl from '../../src/utils/logger-utils/logControl';
import { fetchFeatureFlags } from '../../src/utils/featureFlags';
import layout from '../../src/scss/layout.module.scss';

function Content({ url, query, featureFlags }) {
  const { isAmplienceContent, url: contentPath } = contentPathUrlMapper(
    url,
    false,
    featureFlags
  );

  return (
    <>
      <ESI src={contentPath} id={`content-renderer-${query.path}`} />
    </>
  );
}

export async function getServerSideProps(context) {
  const { resolvedUrl, query } = context;
  const featureFlags = fetchFeatureFlags(context);
  logControl(context);

  return {
    props: {
      url: resolvedUrl,
      query,
      featureFlags,
    },
  };
}

export default Content;
